export default "__VITE_ASSET__C_9m3AcF__"